/** Check-in log, member history, at-risk list and PT pack balance (workers/api/src/{checkin,pt}). */
import type { ApiClient } from "./client";

export interface Checkin {
  id: string; memberId: string; memberName: string; branchId: string; planInstanceId: string | null;
  scannedAt: number; businessDate: string; mode: string; decision: "allow" | "deny"; colour: string; reasons: string[]; flags: string[]; countedAsVisit: boolean;
}
export interface CheckinPage { checkins: Checkin[]; nextCursor: string | null }
export const CHECKIN_PAGE = 50;

export const listCheckins = (c: ApiClient, q: { branchId?: string; date: string; decision?: "allow" | "deny"; cursor?: string | null }) =>
  c.get<CheckinPage>("/checkins", { branchId: q.branchId, date: q.date, decision: q.decision, limit: CHECKIN_PAGE, cursor: q.cursor ?? undefined });
export const listMemberCheckins = (c: ApiClient, memberId: string, cursor?: string | null) =>
  c.get<CheckinPage>(`/members/${memberId}/checkins`, { limit: CHECKIN_PAGE, cursor: cursor ?? undefined });

export interface RiskReason { code: string; severity: "watch" | "at_risk"; value: number; threshold: number; detail: string }
export interface AtRiskMember { memberId: string; name: string; homeBranchId: string | null; level: "watch" | "at_risk"; reasons: RiskReason[] }
export const listAtRisk = (c: ApiClient, q: { level: "watch" | "at_risk"; cursor?: string | null }) =>
  c.get<{ members: AtRiskMember[]; nextCursor: string | null }>("/at-risk-members", { level: q.level, limit: 100, cursor: q.cursor ?? undefined });

export interface PackBalance { planInstanceId: string; memberId: string; status: string; validFrom: string; validTo: string; balance: { total: number; consumed: number; remaining: number; booked: number; available: number } }
export const getPackBalance = (c: ApiClient, planId: string) => c.get<PackBalance>(`/pt/packs/${planId}/balance`);
